import React, { useState, useEffect, useCallback } from "react";
import Image from "../Images/profile.jpg"
import { useNavigate } from "react-router-dom";
import { customerQuery } from "../services/Api";
import moment from "moment";
import { Empty, Flex, Pagination, Spin } from "antd";

const HelpAndSupport = () => {
    const token = localStorage.getItem('token');
    const [query, setQuery] = useState([]);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    console.log(query)

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const getAllQuery = useCallback(() => {
        setIsLoading(true);
        customerQuery(searchQuery, pageSize, currentPage, null)
            .then(response => {
                setQuery(response.data.data);
                setTotal(response.data.total);
            })
            .catch(error => {
                // optionally handle error
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [searchQuery, pageSize, currentPage]);

    useEffect(() => {
        getAllQuery();
    }, [token, getAllQuery]);
    return (
        <div className=" space-y-6 px-5 py-5">
            <div className="space-y-6">
                <div className="flex flex-col space-y-4">
                    <div className="block sm:flex justify-between">
                        <p className="text-base md:text-xl lg:text-2xl text-[#3A4352] font-semibold">Help and Support</p>
                        <div className="relative w-64 mt-5 sm:mt-0">
                            <input
                                className="px-3 h-10 rounded-md bg-[#F0F0F0] outline-none"
                                placeholder="Search"
                                type="search"
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                {isLoading ?
                    <div className='mt-20 flex justify-center items-center'>
                        <Flex gap="middle" vertical>
                            <Spin tip="Loading" size="large">
                                <div className='p-12 rounded-xl'></div>
                            </Spin>
                        </Flex>
                    </div> : (
                        query.length > 0 ? (
                            <>
                                {query.map((queries, index) => (
                                    <div className="border-2 rounded-lg border-blue-200 px-4 cursor-pointer" key={index} onClick={() => navigate('/admin/userallquery', { state: { user_id: queries.user_id } })}>
                                        <div className="block sm:flex sm:justify-between items-center py-3">
                                            <div className="block sm:flex">
                                                <img
                                                    src={queries.user?.profile_photo ? process.env.REACT_APP_API_URL + queries.user?.profile_photo : Image}
                                                    alt=""
                                                    className="rounded-full h-10 w-10 me-5"
                                                />
                                                <div className="">
                                                    <p className="text-base font-medium text-gray-900">{queries.user?.firstName} {queries.user?.lastName}</p>
                                                    <p className="text-sm">{queries.queries && queries?.queries[queries.queries.length - 1]?.message}</p>
                                                </div>
                                            </div>
                                            <div className=" flex sm:block gap-10 sm:gap-0 text-sm text-gray-500 whitespace-nowrap">
                                                <p>{moment(queries.queries && queries?.updatedAt).format('MMM DD')}</p>
                                                <p>{moment(queries.queries && queries?.updatedAt).format('LT')}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <Pagination
                                    align="end"
                                    current={currentPage}
                                    total={total}
                                    pageSize={pageSize}
                                    defaultCurrent={1}
                                    showSizeChanger
                                    pageSizeOptions={['10', '20', '50', '100']}
                                    onChange={handlePageChange}
                                    onShowSizeChange={(page, size) => {
                                        setPageSize(size);
                                        setCurrentPage(1);
                                    }}
                                />
                            </>
                        ) : (<Empty />)
                    )
                }
            </div>
        </div>
    )

}
export default HelpAndSupport;